export default function logError (message) {
	if (typeof console !== 'undefined' && typeof console.error === 'function') {
		console.error(message);
	}
}



// WEBPACK FOOTER //
// ./node_modules/moment-timezone/src/utils/log-error.js